import { client, formatQueryParams } from 'util/sdk';

export default ({ fspId, id, ...params }) =>
  client
    .fsps(fspId)
    .externalDdaAuditLogs.query(
      formatQueryParams({ externalDdaId: id, ...params })
    );
